export default __webpack_public_path__ + "static/button-action-do-5362a3a6e1c83873deb1337464bd835b7c54f26cbefefa6e3b840961e999f8d1.png";